export const extractSeoDescription = (description: string) => {
  // 160 chars of first block
  let result = "";
  try {
    const obj = JSON.parse(description);
    const block = obj.blocks.find((b) => b.type === "paragraph");

    // Remove space before and everything after fullstop.
    const sentance = block.data.text.replace(/^\s+|\..*$/g, "");

    result = sentance.substring(0, 159);

    // eslint-disable-next-line no-empty
  } catch (e) {}
  return result;
};
